import { gql } from '@apollo/client'

export const REFRESH_CREATOR = gql`
  mutation CreateCreatorRefresh($data: CreateCreatorRefreshInput!) {
    createCreatorRefresh(data: $data) {
      success
    }
  }
`
